
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class WoodGrainEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const lines = Math.floor(20 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.1 / (layerIndex + 1);
            for (let i = 0; i < lines; i++) {
                ctx.lineWidth = (2 + this.pseudoRandom(i) * 10) * scale;
                ctx.beginPath();
                ctx.moveTo(-width * 2, (i - lines / 2) * 100 * scale);
                for (let x = -width * 2; x <= width * 2; x += 100) {
                    const noise = Math.sin(x * 0.001 + i) * 50 * scale;
                    ctx.lineTo(x, (i - lines / 2) * 100 * scale + noise);
                }
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
